import { RouteRecordRaw } from 'vue-router';
import { RouteNames } from './types';

export const routes: RouteRecordRaw[] = [
  {
    path: '',
    name: RouteNames.Hazards,
    component: () => import('@/features/hazards/presentation/views/Hazards.vue'),
    children: [
      {
        path: ':hazardType',
        name: RouteNames.HazardByType,
        component: () => import('@/features/hazards/presentation/views/Hazards.vue'),
      },
      {
        path: ':hazardType/:hazardId',
        name: RouteNames.HazardById,
        component: () => import('@/features/hazards/presentation/views/Hazards.vue'),
        meta: { title: 'Hazard Details' },
      },
    ],
    meta: {
      title: 'Home',
    },
  },
  {
    path: '/text-version',
    name: RouteNames.TextVersion,
    component: () => import('@/features/hazards/presentation/views/HazardTextVersion.vue'),
    meta: {
      title: 'Text Only',
    },
  },
  {
    path: '/text-version/:hazardType/:hazardId',
    name: RouteNames.TextVersionById,
    component: () => import('@/features/hazards/presentation/views/HazardTextSingle.vue'),
    meta: {
      title: 'Text Only',
    },
  },
  {
    path: '/about',
    component: () => import('@/common/views/about/About.vue'),
    meta: {
      title: 'About This Site',
    },
  },
  {
    path: '/map-icons',
    component: () => import('@/features/hazards/presentation/views/MapIcons.vue'),
    meta: {
      title: 'Map Icons',
    },
  },
  {
    path: '/map-guide',
    component: () => import('@/features/hazards/presentation/views/MapGuide.vue'),
    meta: {
      title: 'Map Guide',
    },
  },
  {
    path: '/:pathMatch(.*)',
    redirect: {
      name: RouteNames.Hazards,
    },
  },
];
